export const API_BASE = (import.meta.env.VITE_API_BASE as string) || '';
export const ADMIN_ENTRY = (import.meta.env.VITE_ADMIN_ENTRY as string) || 'admin';

export function api(path: string): string {
  return `${API_BASE}${path}`;
}

export const ADMIN_PATH = `/${ADMIN_ENTRY}`;
export const LOGIN_PATH = `/${ADMIN_ENTRY}/login`;
export function adminApi(path: string): string {
  return `${ADMIN_PATH}${path}`;
}